export class BiondMealInterface {
  constructor(subscription, boxId, orderId, biondMealGlobalInterface, biondApi) {
    this.biondApi = biondApi;
    this.biondMealGlobalInterface = biondMealGlobalInterface;
    const lineItems = subscription?.lineItems || [];
    console.log(subscription)
    this.boxes = subscription?.quizPreferences?.boxes || [];

    this.container = document.querySelector('.meal-selection-section');
    this.subscription = subscription;
    this.boxId = boxId;
    this.orderId = orderId;
    console.log(boxId)
    this.box = this.boxes.find(b => b.box_id.toString() === boxId.toString());
    this.lineId = lineItems.find(b => b.variantId.replace('gid://shopify/ProductVariant/','') === this.box?.selectedBox?.id)?.lineId;

    console.log(this.box)
    this.biondMealGlobalInterface.mealTypeIds = this.box?.meal_types || [];
    this.biondMealGlobalInterface.preferenceIds = this.box?.preferences || [];
    this.biondMealGlobalInterface.sideDishIds = this.box?.side_dishs || [];
    this.biondMealGlobalInterface.totalMealsCount = parseInt(this.box?.selectedBox?.mealCount);
    this.biondMealGlobalInterface.boxSizeTitle = this.box?.selectedBox?.title;
    this.totalMealsCountElement = this.container.querySelector('#total-meals-count');
    this.mainActionButton = this.container.querySelector('#main-action-button');
    //this.boxSizeNumber = this.container.querySelector('#box-size-number');
    //this.boxSizeTitle = this.container.querySelector('#box-size-title');
    this.mealTypePreference = this.container.querySelector('#meal-type-preference');
    this.dietaryPreference = this.container.querySelector('.filter-preferences .selected-filter-quiz');
    this.dietaryFilterCheckboxes = this.container.querySelectorAll('.dietary-filter input[type="checkbox"]');
    this.activeIds = {};
    this.sideDishPreference = this.container.querySelector('#side-dish-preference');
    this.isQuiz = false;
    const selectBox = this.container.querySelector('.selected-meal-abo .filter-params');
    if (selectBox) {
      this.renderBoxSelector(selectBox);
    }
    console.log(this.biondMealGlobalInterface)
  }
  /*
  async getProducts(renderBox = true) {
    console.log("selectedMeals GETPRODUCTS")
    this.mealSelectionWrap.classList.add('is-loading');

    if (!this.box) {
      console.warn("❌ Keine gültige Box gesetzt.");
      return;
    }
 
    const params = new URLSearchParams();

    this.mealTypeIds.forEach(id => {
      params.append('filter.p.m.custom.meal_types', `gid://shopify/Metaobject/${id}`);
    });
    params.append("filter.p.status", "ACTIVE"); 
    params.append("filter.p.available", "true");
    params.append("filter.p.inventory_quantity", ">0");

    this.preferenceIds.forEach(id => {
      params.append('filter.p.m.custom.preferences', `gid://shopify/Metaobject/${id}`);
    });




    const url = `${this.getCollectionUrl()}?${params.toString()}`;
    console.log('🔗 Filter-URL:', url);

    try {
      const res = await fetch(url);
      const html = await res.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const grid = doc.querySelector('#product-grid');

      if (!grid) {
        console.warn('❌ Kein #product-grid gefunden.');
        return;
      }

      const content = grid.innerHTML;
      const mealGrid = document.querySelector('#meal-grid');
      mealGrid.innerHTML = "";
      mealGrid.insertAdjacentHTML('beforeend', content);
      if(renderBox){
        this.renderBoxInfo();
      }
      this.mealSelectionWrap.classList.remove('is-loading');
      console.log(this.mealSelectionWrap.classList)
    } catch (err) {
      console.error('❌ Fehler beim Laden der Collection-Seite:', err);
    }
  }

  getMetaobjectNamesByIds(idGroups) {
      const entries = Object.entries(idGroups).flatMap(([groupKey, ids]) =>
        ids.map(id => ({ groupKey, id }))
      );
     
      const query = `query GetMetaobjects {
        ${entries.map(({ id }, index) => `
          obj_${index}: node(id: "${id}") {
            ... on Metaobject {
              fields {
                key
                value
              }
            }
          }
        `).join('')}
      }`;

      return fetch('https://jw9wdd-tu.myshopify.com/api/2024-07/graphql', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': '22d24b254e1f56c5770f0671863f6a97',
        },
        body: JSON.stringify({ query })
      }).then(res => res.json()).then(data => {
        const nameMap = {
          meal_types: [],
          preferences: [],
          side_dishs: []
        };

        entries.forEach(({ groupKey }, index) => {
          const obj = data?.data?.[`obj_${index}`];
          const nameField = obj?.fields?.find(f => f.key === 'name');
          if (nameField) {
            nameMap[groupKey].push(nameField.value);
          }
        });

        return nameMap;
      });
    }
    async getMetaobjectNamesByIds(idGroups) {
    const entries = Object.entries(idGroups).flatMap(([groupKey, ids]) =>
      ids.map(id => ({ groupKey, id }))
    );

    if (entries.length === 0) {
      console.warn('⚠️ Keine IDs übergeben – Abbruch.');
      return {
        meal_types: [],
        preferences: [],
        side_dishs: []
      };
    }

    const query = `
      query GetMetaobjects {
        ${entries.map(({ groupKey, id }) => `
          ${groupKey}_${id}: node(id: "gid://shopify/Metaobject/${id}") {
            ... on Metaobject {
              fields {
                key
                value
              }
            }
          }
        `).join('')}
      }
    `;

    try {
      const response = await fetch('https://jw9wdd-tu.myshopify.com/api/2024-07/graphql', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': '22d24b254e1f56c5770f0671863f6a97',
        },
        body: JSON.stringify({ query })
      });

      const result = await response.json();

      const nameMap = {
        meal_types: [],
        preferences: [],
        side_dishs: []
      };

      entries.forEach(({ groupKey, id }) => {
        const key = `${groupKey}_${id}`;
        const obj = result?.data?.[key];
        const nameField = obj?.fields?.find(f => f.key === 'name');
        if (nameField) {
          nameMap[groupKey].push(nameField.value);
        } else {
          console.warn(`⚠️ Kein Name-Feld für ${key} gefunden.`);
        }
      });

      return nameMap;
    } catch (error) {
      console.error('❌ Fehler beim Abrufen der Metaobject-Namen:', error);
      return {
        meal_types: [],
        preferences: [],
        side_dishs: []
      };
    }
  }*/
  async switchBox(newBoxId) {
    console.log(newBoxId)
    const newBox = this.subscription?.quizPreferences?.boxes?.find(b => b.box_id.toString() === newBoxId.toString());
    console.log(newBox)
    if (!newBox) return;
   
    this.boxId = newBoxId; 
    this.box = newBox;
    this.lineId = this.subscription?.lineItems?.find(b => b.variantId.replace('gid://shopify/ProductVariant/','') === newBox?.selectedBox?.id)?.lineId;

    this.biondMealGlobalInterface.mealTypeIds = newBox?.meal_types || [];
    this.biondMealGlobalInterface.preferenceIds = newBox?.preferences || [];
    this.biondMealGlobalInterface.sideDishIds = newBox?.side_dishs || [];
    this.biondMealGlobalInterface.totalMealsCount = parseInt(newBox?.selectedBox?.mealCount);

    await this.biondMealGlobalInterface.getProducts();
    this.biondMealGlobalInterface.renderBoxInfos();
  }


  renderBoxInfo() {
   
    if (!this.box || !this.container) {
      console.warn('⚠️ Keine Box oder kein Container gesetzt.');
      return;
    }

    const {
      selectedBox = {},
      meal_types = [],
      preferences = [],
      side_dishs = []
    } = this.box;
    
    
    this.boxSizeNumber.textContent = selectedBox.mealCount?.toString() || '0';
    this.totalMealsCountElement.textContent = selectedBox.mealCount?.toString() || '0';
    this.boxSizeTitle.textContent = selectedBox.title || 'Box';
    this.boxSizeNumber.textContent = selectedBox.mealCount?.toString() || '0';
    // 📝 Liste der ausgewählten Mahlzeiten


    // 🏷️ Präferenzen (IDs → Namen)
    this.activeIds = {
      meal_types,
      preferences,
      side_dishs
    };
  
    if (Array.isArray(this.activeIds.preferences)) {
      this.dietaryFilterCheckboxes.forEach(checkbox => {
        if (this.activeIds.preferences.includes(checkbox.value)) {
          checkbox.checked = true;
        }
      });
    }

    this.getMetaobjectNamesByIds(this.activeIds).then(nameMap => {
      this.mealTypePreference.textContent = nameMap.meal_types.join(', ') || '–';
      this.dietaryPreference.textContent = nameMap.preferences.join(', ') || '–';
      this.sideDishPreference.textContent = nameMap.side_dishs.join(', ') || '–';
    });
  }
  renderBoxSelector(container) {
    // Container leeren
    container.innerHTML = '';
    const categoryValue = document.querySelector('.selected-meal-abo .category-value');
    // Checkboxen hinzufügen
  
    this.boxes.forEach(box => {
      
      const boxId = box.box_id;
      const title = box.selectedBox.title;

      const wrapper = document.createElement('div');
      wrapper.classList.add('filter-item');

      const input = document.createElement('input');
      input.type = 'radio';
      input.id = `filter_${boxId}`;
      input.name = 'box_choose';
      input.value = boxId;

      // Optional: vorselektieren
      if (this.boxId === boxId) {
        input.checked = true;
        if (categoryValue) categoryValue.textContent = title;
      }

      const label = document.createElement('label');
      label.setAttribute('for', `filter_${boxId}`);

      const labelText = document.createElement('p');
      labelText.classList.add('filter');
      labelText.textContent = title;

      label.appendChild(labelText);
      wrapper.appendChild(input);
      wrapper.appendChild(label);
      container.appendChild(wrapper);
    });
  }

  async saveMeals() {
        if (!this.biondMealGlobalInterface.selectedMeals || this.biondMealGlobalInterface.selectedMeals.length === 0) {
           showAlert('Du hast noch keine Mahlzeiten ausgewählt.', 'error');
            return;
        }

        const payload = this.biondMealGlobalInterface.selectedMeals.map(meal => ({
            variantId: meal.variantId,
            quantity: meal.quantity || 1
        }));
        console.log(this.biondApi)
        // Disable button while saving to prevent double-clicks
        this.biondMealGlobalInterface.mainActionButton.disabled = true;

        try {
            const result = await this.biondApi.saveMeals(this.orderId, payload, {
                lineId: this.lineId,
                testMode: false
            }); 

            console.log('✅ Mahlzeiten erfolgreich gespeichert:', result);
            showAlert('Deine Auswahl wurde gespeichert!', 'success');
        } catch (error) {
            console.error('❌ Fehler beim Speichern der Mahlzeiten:', error);
            showAlert('Fehler beim Speichern der Mahlzeiten!', 'error');
        } finally {
             // Re-enable button after operation
             this.biondMealGlobalInterface.mainActionButton.disabled = false;
        }
    }

}
